module.exports = __webpack_public_path__ + "img/89.e02b2dfd.jpg";